import React from 'react';
import Contact from '../../components/PublicSite/Contact';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';
import loadSiteCopy from '../../components/PublicSite/loadSiteCopy';

// Route lama merender ./Contact.js (form starter kit). File itu tidak lagi
// diimpor — aman dihapus.
async function action() {
  await loadSiteCopy();
  return {
    title: 'Contact Bas Recovery — Call 050 505 2213 or Request a Callback',
    description: 'Call Bas Recovery on 050 505 2213, WhatsApp us, or request a callback and we will ring you within two minutes. 24/7 roadside assistance across the UAE.',
    component: (
      <HeadLessLayout>
        <Contact />
      </HeadLessLayout>
    ),
  };
}

export default action;
